import styled from "styled-components";
import fipayFonts from "../../../theme/index";
import { colors } from "../../../theme/color";

export const ServiceLeftContainer = styled.div`
  //containing everything on service left
  width: 594px;
  top: 238px;
  left: 110px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;

  @media screen and (max-width: 768px) {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }

  @media screen and (max-width: 430px) {
    width: 327px;
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }

  @media screen and (max-width: 375px) {
    width: 327px;
    /* height: 604px; */
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }
`;

export const ServiceLeftBlock = styled.div`
  //containing text and button
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
`;

export const ServiceLeftTextholder = styled.div`
  //only all the text
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

export const ServiceLeftTextUp = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;

  @media screen and (max-width: 320px) {
    width: 80%;
  }
`;

export const TitleText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.heading1.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  line-height: ${fipayFonts.fipayFonts.lineHeight.heading1};
  color: ${colors.NAVYBLUE};

  @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
    text-align: left;
  }
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
    /* text-align: left; */
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
    /* text-align: left; */
  }
  @media screen and (max-width: 320px) {
    font-size: ${fipayFonts.fipayFonts.body1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
    /* text-align: left; */
  }
`;

export const SubtitleText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.body1.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
  color: ${colors.DARK_GRAY};

  @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    /* line-height: ${fipayFonts.fipayFonts.lineHeight.body2}; */
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }
  @media screen and (max-width: 320px) {
    font-size: ${fipayFonts.fipayFonts.body3.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }
`;

export const ServiceLeftTextDown = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
`;

export const ServiceLeftTextDownCarrier = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 31px;
  @media screen and (max-width: 320px) {
    width: 80%;
  }
`;

export const ServiceLeftTextDownCarrierColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const SmallTitleText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.body2.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  color: ${colors.NAVYBLUE};

  @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  }
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.body3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    /* text-align: left; */
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.body3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.heading2};
    /* text-align: left; */
  }
  @media screen and (max-width: 320px) {
    font-size: ${fipayFonts.fipayFonts.footer1.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body1};
    /* text-align: left; */
  }
`;

export const SmallSubtitleText = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.body2.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
  color: ${colors.DARK_GRAY};
  width: 30.3125rem;

  @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
    width: 100%;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
    width: 100%;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
    width: 100%;
  }
  @media screen and (max-width: 320px) {
    font-size: ${fipayFonts.fipayFonts.body3.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
    color: ${colors.DARK_GRAY};
    text-align: left;
    width: 100%;
  }
`;

//   width: 550px;
//   height: 96px;
//   display: flex;
//   flex-direction: column;
//   justify-content: flex-end;
//   top: 447px;
//   left: 100px;

//   @media screen and (max-width: 1440px) {
//     width: 550px;
//     height: 96px;
//   }

//   @media screen and (max-width: 1024px) {
//     width: 400px;
//     height: 100%;
//   }

//   @media screen and (max-width: 768px) {
//     display: block;
//     width: 550px;
//     height: 72px;
//     display: flex;
//     flex-direction: column;
//     justify-content: flex-end;
//   }

//   @media screen and (max-width: 430px) {
//     display: block;
//     width: 327px;
//     height: 120px;
//     display: flex;
//     flex-direction: column;
//     justify-content: flex-end;
//   }

//   @media screen and (max-width: 375px) {
//     display: block;
//     width: 327px;
//     height: 120px;
//     display: flex;
//     flex-direction: column;
//     justify-content: flex-end;
//   }
// `;
